import { cn } from '@/lib/utils';

interface SectionHeaderProps {
  title: string;
  action?: React.ReactNode;
  className?: string;
}

export function SectionHeader({ title, action, className }: SectionHeaderProps) {
  return (
    <div className={cn('mb-4 flex items-center justify-between', className)}>
      <div className="flex items-center gap-3">
        <span className="block h-6 w-[3px] flex-shrink-0 rounded-full" style={{ backgroundColor: 'var(--section-accent)' }} aria-hidden="true" />
        <h2 className="text-xl leading-tight font-bold text-gray-900">{title}</h2>
      </div>
      {action && <div>{action}</div>}
    </div>
  );
}
